// Recurrence semantics for staff availability (KIN-1671).
//
// `recurring = false` means a single date: the start date. The end date and the
// weekday flags do not apply to such a record — the backend derives them from
// the start date on save — so the UI disables them and they are left out of the
// request rather than sent as values that would only be overwritten.

export const DAY_KEYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const SINGLE_DATE_HINT =
  "Not used for a single date — turn on Recurring to set a range and days";

export const disabledFieldStyle = {
  background: "#f3f4f6",
  color: "#9ca3af",
  cursor: "not-allowed",
};

/**
 * Flips one weekday flag. Returns only the changed field, so callers merge it
 * into their record; a no-op for a single date, where days do not apply.
 */
export const toggleDay = (record, dayId) => {
  if (!record.recurring) return {};

  return { [dayId]: !record[dayId] };
};

/**
 * The recurrence-dependent half of a save payload: every weekday flag and the
 * end date for a recurring record, nothing but the flag for a single date.
 */
export const buildRecurrenceFields = (source) => {
  if (!source.recurring) {
    return { recurring: false };
  }

  return {
    recurring: true,
    availableEndDate: source.availableEndDate || null,
    ...DAY_KEYS.reduce((acc, day) => ({ ...acc, [day]: !!source[day] }), {}),
  };
};

/**
 * Mirrors the backend's constraints (`StaffAvailabilityValidator`) so the user
 * gets a message while they are still in the form, instead of a 400 on save.
 *
 * @returns the message to show, or null when the record is valid
 */
export const validateAvailability = (source) => {
  if (!source.availableStartDate) {
    return "Please enter a start date";
  }

  if (!source.recurring) {
    return null;
  }

  if (!DAY_KEYS.some((day) => source[day])) {
    return "A recurring availability needs at least one day selected";
  }

  if (
    source.availableEndDate &&
    source.availableEndDate < source.availableStartDate
  ) {
    return "The end date cannot be before the start date";
  }

  return null;
};
